import { Outlet } from "react-router";
import AppFooter from "../footer/AppFooter";
import AppSidebar from "../navbar/AppSidebar";
import { useClaimsRefresh } from "../hooks/useClaimsRefresh";

export default function AppLayout() {
  // New role/Gemeinde from an admin take effect without signing in again (GOD-41).
  useClaimsRefresh();
  return (
    <div className="gl-app">
      <AppSidebar />
      <main className="gl-main">
        <Outlet />
        <AppFooter />
      </main>
    </div>
  );
}
